/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
*/

import { combineReducers } from 'redux';

import apiReducer from './api';
import userReducer from './user';
import apiCommentsReducer from './comments';
import ratingsReducer from './ratings';
import documentsReducer from './documents';
import subscriptionsReducer from './subscriptions';
import applicationKeysReducer from './applicationKeys';
import swaggerReducer from './swagger';
import applicationReducer from './applications';
import credentialsReducer from './credentials'
import sdkReducer from './sdk';
import notificationReducer from './notification';
import apiTagsReducer from './tags';
import apiCategoriesReducer from './categories';
import idpReducer from './idps';
import graphqlReducer from "./graphqlResponse";
import addExternalUserToOrgReducer from './addExternalUserToOrg';
import customDomainsOrganizationReducer from './customDomainOrganization';
import subscriptionPoliciesReducer from './subscriptionPolicies';
import organizationMetadataReducer from "./organizationMetadata";
import subscribedApiScopesReducer from "./subscribedApiScopes";
import apiKeysReducer from './apiKeys';

const rootReducer = combineReducers({
    apiReducer: apiReducer,
    userReducer: userReducer,
    apiCommentsReducer: apiCommentsReducer,
    ratingsReducer: ratingsReducer,
    documentsReducer: documentsReducer,
    subscriptionsReducer: subscriptionsReducer,
    applicationKeysReducer: applicationKeysReducer,
    applicationReducer: applicationReducer,
    credentialsReducer: credentialsReducer,
    swaggerReducer: swaggerReducer,
    sdkReducer: sdkReducer,
    notificationReducer: notificationReducer,
    apiTagsReducer: apiTagsReducer,
    apiCategoriesReducer: apiCategoriesReducer,
    idpReducer : idpReducer,
    customDomainOrganizationMappingReducer: customDomainsOrganizationReducer,
    subscriptionPoliciesReducer: subscriptionPoliciesReducer,
    graphqlReducer: graphqlReducer,
    addExternalUserToOrgReducer: addExternalUserToOrgReducer,
    organizationMetadataReducer: organizationMetadataReducer,
    subscribedApiScopesReducer: subscribedApiScopesReducer,
    apiKeysReducer: apiKeysReducer,
});

export default rootReducer;
